import React, { CSSProperties } from "react";

type Props = {
    availableClients: string[];
    selectedClient: string;
    onClientChange: (client: string) => void;
    horizonMonths: number;
    onHorizonChange: (months: number) => void;
    onRefresh: () => void;
    loading: boolean;
};

const HORIZON_OPTIONS = [6, 12, 24];

const clientSelectStyle: CSSProperties = {
    border: 0,
    background: "transparent",
    color: "inherit",
    font: "inherit",
    fontWeight: 600,
    padding: 0,
    cursor: "pointer",
    maxWidth: 160,
};

export const CustomerIntelligenceToolbar: React.FC<Props> = ({
    availableClients,
    selectedClient,
    onClientChange,
    horizonMonths,
    onHorizonChange,
    onRefresh,
    loading,
}) => (
    <div className="filterbar">
        <label className="filter" style={{ padding: "0 8px 0 10px" }}>
            <span aria-hidden className="material-symbols-outlined">
                group
            </span>
            <span className="l">Client:</span>
            <select
                aria-label="Client universe"
                value={selectedClient}
                onChange={(event) => onClientChange(event.target.value)}
                style={clientSelectStyle}
            >
                <option value="">All</option>
                {selectedClient !== "" && !availableClients.includes(selectedClient) ? (
                    <option value={selectedClient}>{selectedClient}</option>
                ) : null}
                {availableClients.map((client) => (
                    <option key={client} value={client}>
                        {client}
                    </option>
                ))}
            </select>
        </label>

        <span className="filter" style={{ padding: "0 4px 0 10px" }}>
            <span aria-hidden className="material-symbols-outlined">
                history
            </span>
            <span className="l">Window:</span>
        </span>
        {HORIZON_OPTIONS.map((months) => (
            <button
                key={months}
                type="button"
                aria-pressed={horizonMonths === months}
                aria-label={`Last ${months} months`}
                onClick={() => onHorizonChange(months)}
                className={horizonMonths === months ? "filter filter--active" : "filter"}
            >
                <span className="v">{months}m</span>
            </button>
        ))}

        <div className="filterbar__spacer" />

        <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="btn btn--primary btn--sm"
        >
            <span aria-hidden className="material-symbols-outlined">
                {loading ? "progress_activity" : "refresh"}
            </span>
            <span>{loading ? "Refreshing…" : "Refresh"}</span>
        </button>
    </div>
);
